import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import { configureStore } from '@reduxjs/toolkit'

import appReducer from '@app/state_management/slices'
import storeReducer from '@features/store-details/state_management/slices'
import topPageReducer from '@features/top/state_management/slices'
import searchStoreReducer from '@features/search-store/state_management/slices'
import voteReducer from '@features/vote-2022/state_management/slices'

export const history = createBrowserHistory()

export const rootReducer = combineReducers({
  router: connectRouter(history),
  app: appReducer,
  store: storeReducer,
  searchStore: searchStoreReducer,
  vote: voteReducer,
  topPage: topPageReducer
})

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false
    })
})

export default store
